import { message } from 'antd';
import { useEvent } from '../../../../../hooks/useEvent';
import { useAcceptanceViewCalendarInvalidate } from '../../../api/acceptanceViewCalendar';

export const useBlockDeleteIntervalSuccess = () => {
  const invalidate = useAcceptanceViewCalendarInvalidate();

  return useEvent((data, variables) => {
    if (data.success === false) {
      message.error(data.message || variables.errorMessage);
      return;
    }

    invalidate();
  });
};
